import script from "./SchoolGradeSubjectSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolGradeSubjectSection.vue?vue&type=script&setup=true&lang=js"

import "./SchoolGradeSubjectSection.vue?vue&type=style&index=0&id=7bf87c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf87c88"]])

export default __exports__